<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Store</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.stores.index')">
                                    Store
                                </Link>
                            </li>
                            <li class="breadcrumb-item active">Available Stores
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="fetchAvailableStores">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Latitude</label>
                                        <input type="text" v-model="store.latitude" class="form-control"
                                               placeholder="Store Latitude"
                                               required>
                                        <div v-if="store.errors.latitude" class="text-danger text-small">
                                            {{ store.errors.latitude }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Longitude</label>
                                        <input type="text" v-model="store.longitude" class="form-control"
                                               placeholder="Store Longitude"
                                               required>
                                        <div v-if="store.errors.longitude" class="text-danger text-small">
                                            {{ store.errors.longitude }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Type</label>
                                        <select v-model="store.type" id="" class="form-control" required>
                                            <option value=1 selected>PICKUP</option>
                                            <option value=2>DELIVERY</option>
                                        </select>
                                        <div v-if="store.errors.type" class="text-danger text-small">
                                            {{ store.errors.type }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="store.use_routes_api"
                                                   id="defaultCheck1"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Use Routes API?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.use_routes_api"
                                              class="text-danger text-small">{{ store.errors.use_routes_api }}</span>
                                    </div>

                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="store.use_straight_line_calculation"
                                                   id="defaultCheck1"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Use Straight Line Calculation?
                                            </label>
                                        </div>
                                        <span v-if="store.errors.use_straight_line_calculation"
                                              class="text-danger text-small">{{
                                                store.errors.use_straight_line_calculation
                                            }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    Search
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <template v-if="availableStores.length > 0">
                <section class="card">
                    <div class="card-body">
                        <h4 class="form-section mb-4"><i class="feather icon-map-pin"></i> Available Stores</h4>
                        <div class="table-responsive">
                            <table class="table table-striped table-hover">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Store Name</th>
                                    <th>Address</th>
                                    <th>Distance</th>
                                    <th>Delivery Price</th>
                                    <th>Latitude</th>
                                    <th>Longitude</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(availableStore, index) in availableStores"
                                    :key="availableStore.id || index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <strong>{{ availableStore.store.name }}</strong>
                                    </td>
                                    <td>
                                        <span class="text-muted">{{ availableStore.store.area }}</span>
                                    </td>
                                    <td>
                                        <span class="badge badge-info">
                                            {{ availableStore.distance }}m
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ availableStore.delivery_price || "Cannot deliver to this distance" }}
                                        </span>
                                    </td>
                                    <td>
                                        <small class="text-muted">{{ availableStore.store.latitude}}</small>
                                    </td>
                                    <td>
                                        <small class="text-muted">{{ availableStore.store.longitude }}</small>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-if="availableStores.length === 0" class="text-center py-4">
                            <i class="feather icon-search" style="font-size: 48px; color: #ddd;"></i>
                            <p class="text-muted mt-2">No stores found for the specified criteria.</p>
                        </div>
                    </div>
                </section>
            </template>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import store from "../Report/Sales/Store.vue";

export default {
    metaInfo: {title: 'Find Available Stores'},
    name: 'AvailableStores',
    props: [],
    components: {},
    layout: Layout,
    data() {
        return {
            store: this.$inertia.form({
                longitude: null,
                latitude: null,
                type: 2,
                use_routes_api: true,
                use_straight_line_calculation: true,
            }),
            saving: false,
            availableStores: [],
        }
    },
    methods: {
        async fetchAvailableStores() {
            try {

                this.saving = true;

                const response = await fetch(route('admin.stores.available-stores.fetch'), {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify(this.store)
                });

                if (!response.ok) {
                    throw new Error('Unable to fetch available stores');
                }

                const resp = await response.json()
                if(!resp.status) {
                    throw new Error('Unable to fetch available stores');
                }
                this.availableStores = resp.data;
                console.log(this.availableStores);
                this.saving = false;
            } catch (error) {
                console.error('Error fetching available stores:', error);
                alert("Unable to fetch available stores");
                this.availableStores = [];
            } finally {
                this.saving = false;
            }
        },
    },
}
</script>
